import autocomplete from './autocomplete';
export default angular
  .module('doxy.common.components.autocomplete', [])
  // autocomplete
  .component('autocomplete', autocomplete).name;
